export const SERVICE_FLOW_CONFIGURATION_MODES = Object.freeze({
  NEW: 'new',
  EDIT: 'edit',
});
